/**
 * Copyright (c) 2016-present GlossGenius. All rights reserved.
 */

import { useStepIndex } from 'hooks/useStepIndex';

import Calendar from '../../components/Icons/Calendar.svg';
import Location from '../../components/Icons/Location.svg';
import Service from '../../components/Icons/Service.svg';
import { Step } from './Step';

import s from './Progress.module.css';

export const Progress = () => {
  const stepIndex = useStepIndex();

  return (
    <nav className={s.root}>
      <Step
        icon={<Service />}
        isSelected={stepIndex === 0}
        isVisited={stepIndex >= 0}
        title="Select Service"
      />
      <Step
        icon={<Location />}
        isSelected={stepIndex === 1}
        isVisited={stepIndex >= 1}
        title="Date & Location"
      />
      <Step
        icon={<Calendar />}
        isSelected={stepIndex === 2}
        isVisited={stepIndex >= 2}
        title="Your Details"
      />
    </nav>
  );
};
